import { render, staticRenderFns } from "./DashboardDeadlineShipping.vue?vue&type=template&id=12931932&scoped=true&"
import script from "./DashboardDeadlineShipping.vue?vue&type=script&lang=js&"
export * from "./DashboardDeadlineShipping.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDeadlineShipping.vue?vue&type=style&index=0&id=12931932&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12931932",
  null
  
)

export default component.exports